import {errHandler} from './config'
import {getToken} from 'UTIL/common'

import {hashHistory} from 'react-router'
const ajax = ({url, body = null, method = 'POST'}) => {
    const defer = $.Deferred()

    console.log("请求服务端" + url + "       参数是" + body);
    $.ajax({
        type: method,
        url: url,
        data: body,
        contentType: "application/json;charset=UTF-8",
        // xhrFields: { // 跨域允许带上 cookie
        //   withCredentials: [域名]
        // },
        crossDomain: true,
        error:function(XMLHttpRequest, textStatus, errorThrown) {
            console.log(textStatus,errorThrown)
            console.log(console.log(JSON.stringify(XMLHttpRequest))); console.log("Error: " + errorThrown);
            //hashHistory.push("/login");
        }

    })
        .done(defer.resolve)
        // .fail(function(res) {
        //     console.log(res)
        // });

    return defer.promise()
}

export default ajax





// WEBPACK FOOTER //
// ./modules/services/ajax/jquery.js